import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("g", { transform: "translate(-8 -8)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13.172 12L8.222 7.05 9.636 5.636 16 12 9.636 18.364 8.222 16.95z",
    transform: "translate(8 8)"
  })
], -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    class: _normalizeClass(["arrow-icon-pagination", [{ disabled: _ctx.disabled }, _ctx.arrowClass]]),
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, _hoisted_2, 2))
}